import { Link, useNavigate } from '@tanstack/react-router'
import type { AdminDeckDto } from '@lunary/api-client'
import { KIND_SHORT } from './kinds'
import expert from '../../shared/ui/expert.module.css'
import styles from './decks-list.module.css'

function Progress({ deck }: { deck: AdminDeckDto }) {
  const daily = deck.kind === 'daily_card'
  const have = daily ? deck.majors_count : deck.cards_count
  const own = deck.custom_cards.length
  const pct = Math.min(100, Math.round((have / Math.max(1, deck.required_count)) * 100))
  return (
    <div className={styles.progress}>
      <span>
        {have} из {deck.required_count}
        {daily && own > 0 ? ` · свои ${own}` : ''}
      </span>
      <span className={styles.bar} aria-hidden="true">
        <i className={have < deck.required_count ? styles.barPart : undefined} style={{ width: `${pct}%` }} />
      </span>
    </div>
  )
}

export function DeckTable({ items }: { items: readonly AdminDeckDto[] }) {
  const navigate = useNavigate()
  return (
    <div className={styles.tableWrap}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Колода</th>
            <th>Тип</th>
            <th>Карты</th>
            <th>Статус</th>
            <th>Автор</th>
          </tr>
        </thead>
        <tbody>
          {items.map((d) => (
            <tr key={d.id} onClick={() => void navigate({ to: '/decks/$deckId', params: { deckId: d.id } })}>
              <td>
                <Link to="/decks/$deckId" params={{ deckId: d.id }} className={styles.name} onClick={(e) => e.stopPropagation()}>
                  {d.back ? <img src={d.back.thumb_url} alt="" draggable={false} /> : <span className={styles.backStd} aria-hidden="true" />}
                  <span>
                    <b>{d.name}</b>
                    {d.description && <small>{d.description}</small>}
                  </span>
                </Link>
              </td>
              <td data-label="Тип">
                <span className={styles.kind} data-kind={d.kind}>
                  {KIND_SHORT[d.kind]}
                </span>
              </td>
              <td data-label="Карты">
                <Progress deck={d} />
              </td>
              <td data-label="Статус">
                <span className={styles.badges}>
                  <span className={d.enabled ? expert.statusPublished : expert.statusDraft}>{d.enabled ? 'включена' : 'выключена'}</span>
                  {d.is_default && <span className={styles.default}>★ основная</span>}
                </span>
              </td>
              <td data-label="Автор" className={styles.owner}>
                {d.owner_name ?? '—'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
